import {injectable} from 'inversify';
import {makeAutoObservable} from 'mobx';

import {i18n} from '@yourcoach/i18n';

import type {Destructible} from '../../../../utils/store';

@injectable()
export class DataFilterLabelsStore implements Destructible {
  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  destruct() {}

  get applyFilters() {
    return i18n.t('shared:apply_filters');
  }

  get filter() {
    return i18n.t('shared:filter');
  }

  get filters() {
    return i18n.t('shared:filters');
  }

  get reset() {
    return i18n.t('shared:reset');
  }

  get searchPlaceholder() {
    return i18n.t('shared:search');
  }

  get total() {
    return i18n.t('shared:total');
  }
}
